<template>
    <b-modal
        id="modal-update-page"
        contentClass="pl-4 pr-4 pt-3 pb-3"
        bodyClass="p-0"
        headerClass="p-0 pb-2"
        footerClass="p-0"
        centered
        hideFooter
        headerCloseContent=""
    >
        <template #modal-title>
            {{ $t('main.modal.title') }}
        </template>
        <div class="p-0">
            {{ $t('main.modal.updatePageMessage') }}
        </div>
        <b-button
            size="s"
            variant="success"
            class="mt-3"
            block
            @click="updatePage"
        >
            {{ $t('main.modal.updatePage') }}
        </b-button>
    </b-modal>
</template>

<script>
export default {
    name: 'ModalUpdatePage',

    methods: {
        updatePage() {
            window.location.reload();
        },
    },
};
</script>